import { useSave } from "./Conexao";

export function useValidarUsuario(fetch) {
  const [validarInterno, validando] = useSave();

  const validar = (tipo, txt, onOk, onRejected) => validarInterno(() => fetch().post(`usuario/auditar/${tipo}`, { txt }), onOk, { onRejected });

  return [validar, validando];
}